var map = {
  "./ru.json": [
    "750792",
    "70022"
  ],
  "./uk.json": [
    "308225",
    "297856"
  ],
  "./bg.json": [
    "145507",
    "523439"
  ],
  "./el.json": [
    "464924",
    "763745"
  ],
  "./en-pt.json": [
    "187456",
    "858441"
  ],
  "./ja.json": [
    "693353",
    "652286"
  ],
  "./ar.json": [
    "981255",
    "412021"
  ],
  "./rw.json": [
    "380615",
    "433842"
  ],
  "./sr.json": [
    "664202",
    "6393"
  ],
  "./lol.json": [
    "114139",
    "883725"
  ],
  "./fr.json": [
    "810262",
    "8324"
  ],
  "./sv.json": [
    "12785",
    "949145"
  ],
  "./as.json": [
    "786291",
    "472123"
  ],
  "./gu.json": [
    "182100",
    "739364"
  ],
  "./kk.json": [
    "703989",
    "510510"
  ],
  "./nb.json": [
    "378823",
    "346774"
  ],
  "./ta.json": [
    "423681",
    "197320"
  ],
  "./ky.json": [
    "694980",
    "611514"
  ],
  "./pl.json": [
    "400194",
    "393615"
  ],
  "./ro.json": [
    "723602",
    "803663"
  ],
  "./ka.json": [
    "65680",
    "541212"
  ],
  "./hu.json": [
    "205523",
    "718069"
  ],
  "./ur.json": [
    "94379",
    "97784"
  ],
  "./or.json": [
    "517432",
    "869796"
  ],
  "./uz.json": [
    "835246",
    "268622"
  ],
  "./hy.json": [
    "542047",
    "827579"
  ],
  "./de.json": [
    "775586",
    "527918"
  ],
  "./pt-pt.json": [
    "53599",
    "444810"
  ],
  "./es-cl.json": [
    "950456",
    "958616"
  ],
  "./vi.json": [
    "8272",
    "390675"
  ],
  "./tr.json": [
    "412066",
    "722205"
  ],
  "./da.json": [
    "772067",
    "618418"
  ],
  "./kn.json": [
    "838477",
    "998874"
  ],
  "./mr.json": [
    "821799",
    "669471"
  ],
  "./id.json": [
    "208172",
    "70548"
  ],
  "./lt.json": [
    "979522",
    "379102"
  ],
  "./lv.json": [
    "260824",
    "175601"
  ],
  "./fv.json": [
    "631628",
    "54756"
  ],
  "./zh-hans.json": [
    "1016",
    "562822"
  ],
  "./es.json": [
    "282870",
    "271464"
  ],
  "./ko.json": [
    "124992",
    "594408"
  ],
  "./te.json": [
    "995506",
    "653582"
  ],
  "./bn.json": [
    "716105",
    "509175"
  ],
  "./cs.json": [
    "627011",
    "903519"
  ],
  "./boxes.json": [
    "116835",
    "687819"
  ],
  "./my.json": [
    "591931",
    "104709"
  ],
  "./mn.json": [
    "625960",
    "486749"
  ],
  "./sk.json": [
    "300662",
    "158163"
  ],
  "./nl.json": [
    "170291",
    "10594"
  ],
  "./az.json": [
    "369008",
    "897572"
  ],
  "./accents.json": [
    "737005",
    "962998"
  ],
  "./pa.json": [
    "26749",
    "329488"
  ],
  "./pt.json": [
    "972321",
    "390158"
  ],
  "./it.json": [
    "919224",
    "153057"
  ],
  "./km.json": [
    "55875",
    "7617"
  ],
  "./hi.json": [
    "338393",
    "71256"
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 621678;
module.exports = webpackAsyncContext;
